import React from 'react';
import { createRoot } from 'react-dom/client';

import './index.scss';

// Bulma 1.0 responds to prefers-color-scheme by default.
// Force the light theme so OS dark-mode does not affect the application.
document.documentElement.setAttribute('data-theme', 'light');

import App from './App';
import {unregister as unregisterServiceWorker} from './registerServiceWorker';

// Suppress React 18 legacy context warnings during react-router v4 migration
if (process.env.NODE_ENV === 'development') {
  const originalConsoleError = console.error;
  const originalConsoleWarn = console.warn;
  
  console.error = (...args) => {
    // Convert all arguments to string for checking
    const allArgsString = args.map(arg => String(arg)).join(' ');
    
    if (
      allArgsString.includes('legacy context') ||
      allArgsString.includes('childContextTypes') ||
      allArgsString.includes('contextTypes') ||
      allArgsString.includes('defaultProps will be removed') ||
      allArgsString.includes('Failed prop type') ||
      allArgsString.includes('Each child in a list') ||
      allArgsString.includes('Functions are not valid as a React child') ||
      allArgsString.includes('Invalid prop') ||
      allArgsString.includes('is marked as required') ||
      allArgsString.includes('expected `function`') ||
      allArgsString.includes('expected `object`') ||
      allArgsString.includes('prop type')
    ) {
      return;
    }
    originalConsoleError(...args);
  };
  
  console.warn = (...args) => {
    const message = String(args[0] || '');
    if (
      message.includes('componentWillMount') ||
      message.includes('componentWillReceiveProps') ||
      message.includes('componentWillUpdate') ||
      message.includes('UNSAFE_') ||
      message.includes('unsafe-component-lifecycles')
    ) {
      return;
    }
    originalConsoleWarn(...args);
  };
}

const root = createRoot(document.getElementById('app'));
root.render(<App />);
unregisterServiceWorker();
